import { Component, EventEmitter, Input, Output } from '@angular/core';

export type StepperStep = {
  label: string;
  icon?: string;
  doneIcon?: string;
  invalidIcon?: string;
};

@Component({
  selector: 'sag-ui-stepper',
  templateUrl: './stepper.component.html',
})
export class StepperComponent {
  @Input() steps: StepperStep[] = [];
  @Input() active = 0;
  @Input() invalidSteps: number[] = [];
  @Input() disabledSteps: number[] = [];
  @Input() orientation: 'horizontal' | 'vertical' = 'horizontal';

  @Output() selectedChange: EventEmitter<number> = new EventEmitter<number>();

  protected getState(
    index: number,
  ): 'active' | 'done' | 'default' | 'disabled' | 'error' {
    if (this.invalidSteps.includes(index)) {
      return 'error';
    }

    if (this.disabledSteps.includes(index)) {
      return 'disabled';
    }

    if (index === this.active) {
      return 'active';
    }

    if (index < this.active) {
      return 'done';
    }

    return 'default';
  }

  protected stepDone(index: number): boolean {
    return index < this.active;
  }

  protected containerClasses(index: number): string {
    const baseStyles =
      this.orientation === 'horizontal'
        ? 'w-full flex items-center pt-[16px] pb-[16px] rounded-md'
        : 'flex flex-col items-center pl-[16px] pr-[16px] rounded-md';

    return (
      baseStyles +
      (this.getState(index) === 'active'
        ? ' bg-[#F3F3F0] dark:bg-[#4d4d54] dark:bg-opacity-[45%]'
        : '')
    );
  }

  protected isDisabled(index: number): boolean {
    return this.disabledSteps.includes(index);
  }

  protected isInvalid(index: number): boolean {
    return this.invalidSteps.includes(index);
  }
}
